export default "__VITE_ASSET__CFZs4OI4__"